import { buildIncptPriceHistory } from '@incpt/shared';
import type { PresaleOverview, PresalePurchase, PresaleRound, PresaleTokenStats } from './presale';

const DAY_MS = 86_400_000;

export const MOCK_ROUND: PresaleRound = {
  symbol: 'INCPT',
  price: 0.3,
  minAmount: 100,
  marketPrice: 0.4,
  marketChange24h: 25,
  open: true,
  networks: [{ id: 'trc20', label: 'TRC-20 · TRON', short: 'TRC-20' }],
  treasuryTrx: null,
};

export const MOCK_STATS: PresaleTokenStats = {
  marketCap: 40_000_000,
  volume24h: 400_000,
  createdYear: 2026,
};

const SEEDS: { daysAgo: number; amount: number }[] = [
  { daysAgo: 81, amount: 100 },
  { daysAgo: 126, amount: 100 },
  { daysAgo: 182, amount: 100 },
];

function toPurchase(s: { daysAgo: number; amount: number }, now: number): PresalePurchase {
  return {
    id: `ps-${s.daysAgo}`,
    amount: s.amount,
    tokens: s.amount / MOCK_ROUND.price,
    price: MOCK_ROUND.price,
    createdAt: new Date(now - s.daysAgo * DAY_MS).toISOString(),
    status: 'settled',
  };
}

export const holdings = (purchases: PresalePurchase[]) =>
  purchases.reduce((sum, p) => sum + p.tokens, 0);

export function mockPresale(now = Date.now()): PresaleOverview {
  const purchases = SEEDS.map((s) => toPurchase(s, now));
  return {
    visible: true,
    round: MOCK_ROUND,
    purchases,
    balance: String(holdings(purchases)),
    priceHistory: buildIncptPriceHistory(MOCK_ROUND.marketPrice, now),
    stats: MOCK_STATS,
  };
}
